import React, { ComponentType, FC } from 'react'
import cx from 'classnames'
import { Size, Color, Align, NbOfCols, SizeImg } from './types'
import './padding.scss'
import './margin.scss'
import './align.scss'
import './colors.scss'

export type NumberOfCols = NbOfCols
export type SizeImage = SizeImg
export type Colors = Color

export type styleProviderProps = {
  display?: string
  margin?: Size
  padding?: Size
  smMargin?: Size
  smPadding?: Size
  mdMargin?: Size
  mdPadding?: Size
  color?: Color
  align?: Align
  smAlign?: Align
  mdAlign?: Align
  isBold?: boolean
  isUnderline?: boolean
  hasVerticalAlign?: boolean
  hasVerticalAlignForDesktop?: boolean
}

/**
 * styleProvider
 *
 * Add margin, padding, align & color to component to wrap
 *
 * @param {func} ComponentToWrap React component
 * @return {func}
 */
export const styleProvider = <P extends object>(
  ComponentToWrap: ComponentType<P & { classes: string }>,
): FC<P & styleProviderProps> => {
  return ({
    display,
    margin,
    padding,
    smMargin,
    smPadding,
    mdMargin,
    mdPadding,
    color,
    align,
    smAlign,
    mdAlign,
    hasVerticalAlign,
    hasVerticalAlignForDesktop,
    isBold,
    isUnderline,
    ...otherProps
  }: styleProviderProps) => {
    return (
      <ComponentToWrap
        {...(otherProps as P)}
        classes={cx({
          [`${display}`]: display,
          [`margin-${margin}`]: margin,
          [`padding-${padding}`]: padding,
          [`sm-margin-${smMargin}`]: smMargin,
          [`sm-padding-${smPadding}`]: smPadding,
          [`md-margin-${mdMargin}`]: mdMargin,
          [`md-padding-${mdPadding}`]: mdPadding,
          [`color-${color}`]: color,
          [`align-${align}`]: align,
          [`sm-align-${smAlign}`]: smAlign,
          [`md-align-${mdAlign}`]: mdAlign,
          verticalAlign: hasVerticalAlign,
          verticalAlignForDesktop: hasVerticalAlignForDesktop,
          bold: isBold,
          underline: isUnderline,
        })}
      />
    )
  }
}

export default styleProvider
